import { styled } from '@mui/material/styles';
import { Box, Paper, Button, Chip as MuiChip } from '@mui/material';

// export const GeneralContainer = styled(Box)(() => ({
//   display: 'grid',
//   gridTemplateColumns: '300px 1fr',
//   gap: 0,
//   minHeight: '500px',
//   border: '1px solid #e0e0e0',
//   borderRadius: '8px',
//   overflow: 'hidden',
//   backgroundColor: '#fff',
//   marginTop: '8px',
// }));

export const GeneralContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '300px 1fr',
  gap: 0,
  minHeight: '500px',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '8px',
  overflow: 'hidden',
  backgroundColor: theme.palette.background.paper,
  marginTop: '8px',
}));

/* ─── Sidebar de filtros (esquerda) ─── */

export const FilterSidebar = styled(Box)(({ theme }) => ({
  borderRight: `1px solid ${theme.palette.divider}`,
  padding: '16px',
  backgroundColor: theme.palette.background.default,
  overflowY: 'auto' as const,
  display: 'flex',
  flexDirection: 'column' as const,
}));

export const FilterSection = styled(Box)(({ theme }) => ({
  marginBottom: '16px',
}));

export const FilterSectionTitle = styled('span')(({ theme }) => ({
  fontSize: '11px',
  color: theme.palette.text.secondary,
  fontWeight: 600,
  textTransform: 'uppercase' as const,
  letterSpacing: '0.5px',
  display: 'block',
  margin: '10px 10px 10px 0px',
}));

export const ToggleRow = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '4px 0',
}));

export const ToggleLabel = styled('span')(() => ({
  fontSize: '13px',
  color: '#444',
  fontWeight: 500,
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
}));

export const QuickPeriodContainer = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap' as const,
  gap: '5px',
  marginBottom: '10px',
}));

export const QuickPeriodButton = styled(Button)<{ selected?: boolean }>(({ selected }) => ({
  padding: '3px 8px',
  fontSize: '11px',
  fontWeight: 500,
  borderRadius: '6px',
  border: `1px solid ${selected ? '#1976d2' : '#ddd'}`,
  backgroundColor: selected ? '#e3f2fd' : '#fff',
  color: selected ? '#1565c0' : '#666',
  textTransform: 'none' as const,
  minWidth: 'unset',
  lineHeight: 1.4,
  '&:hover': {
    borderColor: '#1976d2',
    backgroundColor: selected ? '#e3f2fd' : '#f5f5f5',
  },
}));

export const StatusButtonGroup = styled('div')(() => ({
  display: 'flex',
  gap: '5px',
}));

export const StatusButton = styled(Button)<{
  selected?: boolean;
  statusType?: 'all' | 'success' | 'error';
}>(({ selected, statusType }) => {
  let bgColor = '#fff';
  let borderColor = '#ddd';
  let textColor = '#666';

  if (selected) {
    if (statusType === 'error') {
      bgColor = '#fbe9e7';
      borderColor = '#d32f2f';
      textColor = '#c62828';
    } else if (statusType === 'success') {
      bgColor = '#e8f5e9';
      borderColor = '#4caf50';
      textColor = '#2e7d32';
    } else {
      bgColor = '#e3f2fd';
      borderColor = '#1976d2';
      textColor = '#1565c0';
    }
  }

  return {
    flex: 1,
    padding: '5px 0',
    fontSize: '11px',
    fontWeight: 500,
    borderRadius: '6px',
    border: `1px solid ${borderColor}`,
    backgroundColor: bgColor,
    color: textColor,
    textTransform: 'none' as const,
    minWidth: 'unset',
    '&:hover': {
      borderColor: '#1976d2',
      backgroundColor: selected ? bgColor : '#f5f5f5',
    },
  };
});

export const SearchButton = styled(Button)(() => ({
  width: '100%',
  height: '34px',
  backgroundColor: '#1976d2',
  color: '#fff',
  fontWeight: 500,
  fontSize: '12px',
  textTransform: 'none' as const,
  borderRadius: '6px',
  marginTop: '8px',
  '&:hover': {
    backgroundColor: '#1565c0',
  },
}));

export const ClearButton = styled(Button)(() => ({
  width: '100%',
  color: '#888',
  fontSize: '11px',
  textTransform: 'none' as const,
  marginTop: '2px',
  '&:hover': {
    color: '#333',
    backgroundColor: 'transparent',
  },
}));

/* ─── Painel direito (cards + tabela empilhados) ─── */

export const RightPanel = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column' as const,
  overflow: 'hidden',
}));

/* ─── Overview cards (compactos, dentro do painel direito) ─── */

export const ContainerCards = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr',
  gap: '10px',
  padding: '12px 14px',
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.default,
}));

export const OverviewCard = styled(Paper)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '10px 14px',
  borderRadius: '8px',
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: 'none',
  backgroundColor: theme.palette.background.paper,
  minHeight: 'unset',
}));

export const OverviewValue = styled('span')(() => ({
  fontSize: '22px',
  fontWeight: 600,
  color: '#333',
  lineHeight: 1.1,
}));

export const OverviewLabel = styled('span')(() => ({
  fontSize: '11px',
  color: '#999',
  fontWeight: 500,
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
  marginBottom: '2px',
}));

export const OverviewTrend = styled('span')<{ variant?: 'up' | 'down' }>(({ variant }) => ({
  fontSize: '10px',
  fontWeight: 500,
  display: 'flex',
  alignItems: 'center',
  gap: '3px',
  marginTop: '2px',
  color: variant === 'down' ? '#c62828' : '#2e7d32',
}));

export const SparklineContainer = styled('div')(() => ({
  width: '50px',
  height: '24px',
  flexShrink: 0,
}));

/* ─── Card "Não entregues" (compacto) ─── */

export const NotDeliveredCard = styled(Paper)(({ theme }) => ({
  padding: '10px 14px',
  borderRadius: '8px',
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: 'none',
  backgroundColor: theme.palette.background.paper,
}));

export const NotDeliveredRow = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '3px 0',
}));

export const NotDeliveredLabel = styled('span')(() => ({
  fontSize: '11px',
  color: '#666',
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
  minWidth: '70px',
}));

export const NotDeliveredBarWrapper = styled('div')(() => ({
  flex: 1,
  height: '5px',
  backgroundColor: '#f0f0f0',
  borderRadius: '3px',
  overflow: 'hidden',
  margin: '0 8px',
}));

export const NotDeliveredBar = styled('div')<{ width: string }>(({ width }) => ({
  height: '100%',
  borderRadius: '3px',
  backgroundColor: '#d32f2f',
  width,
  transition: 'width 0.3s ease',
}));

export const NotDeliveredValue = styled('span')(() => ({
  fontSize: '13px',
  fontWeight: 600,
  color: '#c62828',
  minWidth: '24px',
  textAlign: 'right' as const,
}));

/* ─── Área da tabela (abaixo dos cards) ─── */

export const TableArea = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column' as const,
  flex: 1,
  overflow: 'hidden',
}));

export const TableHeader = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '10px 14px',
  borderBottom: '1px solid #f0f0f0',
}));

export const TableTitle = styled('span')(() => ({
  fontSize: '13px',
  fontWeight: 500,
  color: '#333',
}));

export const TableCount = styled('span')(() => ({
  fontSize: '11px',
  color: '#999',
  marginLeft: '8px',
  fontWeight: 400,
}));

export const ChipsRow = styled(Box)(() => ({
  display: 'flex',
  gap: '5px',
  flexWrap: 'wrap' as const,
  padding: '8px 14px',
  borderBottom: '1px solid #f0f0f0',
}));

export const FilterChip = styled(MuiChip)(() => ({
  height: '22px',
  fontSize: '10px',
  fontWeight: 500,
  backgroundColor: '#e3f2fd',
  color: '#1565c0',
  borderRadius: '11px',
  '& .MuiChip-deleteIcon': {
    fontSize: '13px',
    color: '#1565c0',
    opacity: 0.6,
    '&:hover': { opacity: 1 },
  },
}));

export const TableScrollArea = styled(Box)(() => ({
  flex: 1,
  overflowY: 'auto' as const,
}));

export const TableFooter = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px 14px',
  borderTop: '1px solid #eee',
  backgroundColor: '#fafafa',
}));

export const FooterText = styled('span')(() => ({
  fontSize: '11px',
  color: '#999',
}));

/* ─── Badges de status ─── */

export const StatusBadge = styled('span')<{ status: 'success' | 'error' }>(({ status }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  fontSize: '10px',
  fontWeight: 600,
  padding: '2px 8px',
  borderRadius: '6px',
  backgroundColor: status === 'success' ? '#e8f5e9' : '#fbe9e7',
  color: status === 'success' ? '#2e7d32' : '#c62828',
  whiteSpace: 'nowrap' as const,
}));

export const StatusDot = styled('span')<{ status: 'success' | 'error' }>(({ status }) => ({
  width: '6px',
  height: '6px',
  borderRadius: '50%',
  backgroundColor: status === 'success' ? '#4caf50' : '#d32f2f',
  flexShrink: 0,
}));

/* ─── Channel icon na tabela ─── */

export const ChannelCell = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  fontSize: '12px',
  fontWeight: 500,
  color: '#333',
  whiteSpace: 'nowrap' as const,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  '& svg': {
    width: '14px',
    height: '14px',
    opacity: 0.4,
    flexShrink: 0,
  },
}));

export const DetailButton = styled(Button)(() => ({
  fontSize: '11px',
  color: '#1976d2',
  fontWeight: 500,
  textTransform: 'none' as const,
  padding: '2px 6px',
  minWidth: 'unset',
  borderRadius: '4px',
  '&:hover': {
    backgroundColor: '#e3f2fd',
  },
}));